import moment from "moment";
import { ROLES_TAB } from "../../framework/tab/tabUtilsConstants";

export const privilege_groups = [
  {
    groupId: "SALES",
    groupLabel: "Sales",
    privileges: [
      {
        id: "SALES_CREATE",
        label: "Create",
        desc: "Allows the user to create new sales transactions",
      },
      {
        id: "SALES_EDIT",
        label: "Edit",
        desc: "Allows the user to edit sales transactions",
      },
      {
        id: "SALES_DELETE",
        label: "Delete",
        desc: "Allows the user to delete sales transactions",
      },
      {
        id: "SALES_VIEW",
        label: "View",
        desc: "Read all sales transactions",
      },
      {
        id: "BATCH_CREATE",
        label: "Add New Batch",
        desc: "Allows the user to add new batch for the selected product",
      },
      {
        id: "SALES_EDIT_PRODUCTS",
        label: "Edit Product details",
        desc: "Allows the user to edit product details",
      },
      {
        id: "SALES_BILL_REPRINT",
        label: "Bill Re-Printing",
        desc: "Allows the user to print duplicate sales bills from report",
      },
      {
        id: "REPORT_HOME_DELIVERY",
        label: "Home Delivery",
        desc: "Allows the user to manage home delivery orders",
      },
      {
        id: "SCHEDULE_ORDER_CREATE",
        label: "Create Schedule Order",
        desc: "Allows the user to create new schedule orders",
      },
      {
        id: "SCHEDULE_ORDER_VIEW",
        label: "Schedule Order Report",
        desc: "Allows the user to manage schedule orders",
      },
      {
        id: "EDITED_SALES_REPORT",
        label: "Edited Sales Bill",
        desc: "Allows the user to view the history of edited sales bills",
      },
    ],
  },
  {
    groupId: "SALES_B2B",
    groupLabel: "Sales B2B",
    privileges: [
      {
        id: "SALES_B2B_CREATE",
        label: "Create",
        desc: "Allows the user to create new sales b2b transactions",
      },
      {
        id: "SALES_B2B_EDIT",
        label: "Edit",
        desc: "Allows the user to edit sales b2b transactions",
      },
      {
        id: "SALES_B2B_VIEW",
        label: "View",
        desc: "Read all sales b2b transactions",
      },
      {
        id: "SALES_B2B_DELETE",
        label: "Delete",
        desc: "Delete sales b2b transactions",
      },
    ],
  },
  {
    groupId: "PURCHASE",
    groupLabel: "Purchase",
    privileges: [
      {
        id: "PURCHASE_VIEW",
        label: "View",
        desc: "Read all purchase transactions",
      },
      {
        id: "PURCHASE_CREATE",
        label: "Create",
        desc: "Allows the user to create new purchase transactions",
      },
      {
        id: "PURCHASE_DELETE",
        label: "Delete",
        desc: "Allows the user to delete purchase transactions",
      },
      {
        id: "PURCHASE_EDIT",
        label: "Edit",
        desc: "Allows the user to edit purchase transactions",
      },
      {
        id: "PURCHASE_PRINT_BARCODE",
        label: "Print Barcode",
        desc: "Allows the users to print Barcodes explicitly",
      },
      {
        id: "PURCHASE_EMAILS",
        label: "Emails",
        desc: "Read and process emails",
      },
      {
        id: "APO_CREATE",
        label: "Auto Place Order (APO)",
        desc: "Allows the users to create auto purchase orders",
      },
      {
        id: "APO_VIEW",
        label: "Auto Placed Order Report",
        desc: "Allows the users to view auto purchase orders",
      },
    ],
  },
  {
    groupId: "SHORT_BOOK",
    groupLabel: "Short Book",
    privileges: [
      {
        id: "DEMAND_BOOK_CREATE",
        label: "Create",
        desc: "Allows the user to create new shortbook entries",
      },
      {
        id: "DEMAND_BOOK_EDIT", //Not present in PharmacyPro Roles & Permissions Setting for DMart File
        label: "Edit",
        desc: "Allows the user to edit shortbook entries",
      },
      {
        id: "DEMAND_BOOK_DELETE",
        label: "Delete",
        desc: "Allows the user to delete shortbook entries",
      },
      {
        id: "DEMAND_BOOK_VIEW",
        label: "View",
        desc: "Allows the user to view shortbook entries",
      },
    ],
  },
  {
    groupId: "PROMISE_ORDER",
    groupLabel: "Promise Order",
    privileges: [
      {
        id: "PROMISE_ORDER_CREATE",
        label: "Create",
        desc: "Allows the user to create new promise order entries",
      },
      {
        id: "PROMISE_ORDER_EDIT", //Not present in PharmacyPro Roles & Permissions Setting for DMart File
        label: "Edit",
        desc: "Allows the user to edit promise order entries",
      },
      {
        id: "PROMISE_ORDER_DELETE",
        label: "Delete",
        desc: "Allows the user to delete promise order entries",
      },
      {
        id: "PROMISE_ORDER_RESOLVE",
        label: "Resolve",
        desc: "Allows the user to resolve existing promise order",
      },
      {
        id: "PROMISE_ORDER_VIEW",
        label: "View",
        desc: "Allows the user to view promise order entries",
      },
      {
        id: "REPORTS_PROMISE_ORDER",
        label: "Promise Order Report",
        desc: "Allows the user to view promise order report",
      },
    ],
  },
  {
    groupId: "SALES_RETURN",
    groupLabel: "Sales return",
    privileges: [
      {
        id: "SALES_RETURN_CREATE",
        label: "Create",
        desc: "Allows the user to create new sales return transactions",
      },
      {
        id: "SALES_RETURN_EDIT",
        label: "Edit",
        desc: "Allows the user to edit sales return transactions",
      },
      {
        id: "SALES_RETURN_DELETE",
        label: "Delete",
        desc: "Allows the user to delete sales return transactions",
      },
      {
        id: "SALES_RETURN_VIEW",
        label: "View",
        desc: "Read all sales return transactions",
      },
    ],
  },
  {
    groupId: "PURCHASE_RETURN",
    groupLabel: "Purchase return",
    privileges: [
      {
        id: "PURCHASE_RETURN_CREATE",
        label: "Create",
        desc: "Allows the user to create new purchase return transactions",
      },
      {
        id: "PURCHASE_RETURN_EDIT",
        label: "EDIT",
        desc: "Edit all purchase return transactions",
      },
      {
        id: "PURCHASE_RETURN_DELETE",
        label: "Delete",
        desc: "Allows the user to delete purchase return transactions",
      },
      {
        id: "PURCHASE_RETURN_VIEW",
        label: "View",
        desc: "Read all purchase return transactions",
      },
    ],
  },
  {
    groupId: "DISTRIBUTOR_PAYMENT",
    groupLabel: "Distributor Payment",
    privileges: [
      {
        id: "DISTRIBUTOR_PAYMENTS_CREATE",
        label: "Create",
        desc: "Allows the user to create new distributor payment transactions",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_EDIT",
        label: "EDIT",
        desc: "Allows the user to edit distributor payment transactions",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_DELETE",
        label: "Delete",
        desc: "Allows the user to delete distributor payment transactions",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_VIEW",
        label: "View",
        desc: "Read all distributor payment transactions",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_BILL_REPRINT",
        label: "Bill Re-printing",
        desc: "Allow user to print duplicate payment bill from reports.",
      },
    ],
  },
  {
    groupId: "PATIENT_PAYMENT",
    groupLabel: "Patient Payment",
    privileges: [
      {
        id: "PATIENT_PAYMENT_CREATE",
        label: "Create",
        desc: "Allows the user to create new patient payment transactions",
      },
      {
        id: "PATIENT_PAYMENT_EDIT",
        label: "EDIT",
        desc: "Allows the user to edit patient payment transactions",
      },
      {
        id: "PATIENT_PAYMENT_DELETE",
        label: "Delete",
        desc: "Allows the user to delete patient payment transactions",
      },
      {
        id: "PATIENT_PAYMENT_VIEW",
        label: "View",
        desc: "Read all patient payment transactions",
      },
      {
        id: "PATIENT_PAYMENT_SHOW_BANK_TXN",
        label: "Allow Bank transactions",
        desc: "Allows user to accept bank txn like Cheque, RTGS, IMPS, NEFT",
      },
      {
        id: "PATIENT_PAYMENT_BILL_REPRINT",
        label: "Bill Re-printing",
        desc: "Allow user to print duplicate payment bill from reports.",
      },
    ],
  },
  {
    groupId: "ACCOUNTING",
    groupLabel: "Accounting",
    privileges: [
      {
        id: "ACCOUNTING_CREATE",
        label: "Create Voucher",
        desc: "Allows the user to create new voucher transactions",
      },
      {
        id: "ACCOUNTING_EDIT",
        label: "Edit Voucher",
        desc: "Allows the user to edit voucher transactions",
      },
      {
        id: "ACCOUNTING_DELETE",
        label: "Delete Voucher",
        desc: "Allows the user to delete voucher transactions",
      },
      {
        id: "ACCOUNTING_VIEW",
        label: "View Voucher",
        desc: "Read all voucher transactions",
      },
      {
        id: "ACCOUNTING_CHARTS_OF_ACCOUNT",
        label: "View Charts of Account",
        desc: "Allows the user to view all accounts",
      },
      {
        id: "ACCOUNTING_LEDGER_DETAILS",
        label: "View Ledger Details",
        desc: "Allows the user to view all ledgers",
      },
      {
        id: "ACCOUNTING_TRIAL_BALANCE",
        label: "View Trial Balance Report",
        desc: "Allows the user to view and export the report",
      },
      {
        id: "ACCOUNTING_PROFIT_AND_LOSS",
        label: "View Profit and Loss Report",
        desc: "Allows the user to view and export the report",
      },
      {
        id: "ACCOUNTING_STANDARD_PROFIT_AND_LOSS",
        label: "View Standard Profit and Loss Report",
        desc: "Allows the user to view and export the report",
      },
      {
        id: "ACCOUNTING_GSTR",
        label: "GSTR Report",
        desc: "Allows the user to export the GSTR reports",
      },
      {
        id: "ACCOUNTING_GST_SUMMARY",
        label: "GSTR Summary Report",
        desc: "Allows the user to view and export the GST summary report",
      },
      {
        id: "REPORT_EXPENSE",
        label: "Expense Report",
        desc: "Allow users to create, view and export expense report",
      },
    ],
  },
  {
    groupId: "USER",
    groupLabel: "User",
    privileges: [
      {
        id: "ACCESS_CONTROL_CREATE",
        label: "Create",
        desc: "Allows the user to create new users",
      },
      {
        id: "ACCESS_CONTROL_EDIT",
        label: "Edit",
        desc: "Allows the user to edit users",
      },
      {
        id: "ACCESS_CONTROL_DELETE",
        label: "Delete",
        desc: "Allows the user to delete users",
      },
      {
        id: "ACCESS_CONTROL_VIEW",
        label: "View",
        desc: "Allows the user to view users",
      },
      {
        id: "SALES_DELIVERY_AGENT",
        label: "Sales Delivery Agent",
        desc: "Assigns the user as delivery agent",
      },
    ],
  },
  {
    groupId: "ROLES",
    groupLabel: "Roles",
    privileges: [
      {
        id: "ROLES_CREATE",
        label: "Create",
        desc: "Allows the user to create new roles",
      },
      {
        id: "ROLES_EDIT",
        label: "Edit",
        desc: "Allows the user to edit roles",
      },
      {
        id: "ROLES_DELETE",
        label: "Delete",
        desc: "Allows the user to delete roles",
      },
      {
        id: "ROLES_VIEW",
        label: "View",
        desc: "Allows the user to view roles",
      },
    ],
  },
  {
    groupId: "CONFIGURATION",
    groupLabel: "Configuration",
    privileges: [
      {
        id: "CONFIGURATION_VIEW",
        label: "View/Edit",
        desc: "Allows the user to view/edit roles",
      },
    ],
  },
  {
    groupId: "MASTER",
    groupLabel: "Master",
    privileges: [
      {
        id: "PATIENT_CREATE",
        label: "Add New Patient",
        desc: "Allows the user to add new patient",
      },
      {
        id: "PATIENT_EDIT",
        label: "Edit Patient",
        desc: "Allows the user to edit patient details",
      },
      {
        id: "PATIENT_DELETE",
        label: "Delete Patient",
        desc: "Allows the user to delete patient ",
      },
      {
        id: "PATIENT_VIEW",
        label: "View Patient Master",
        desc: "Allows the user to view and export patient master",
      },
      {
        id: "PATIENT_REMAP",
        label: "Merge Patient",
        desc: "Allows the user to merge two patients",
      },
      {
        id: "DOCTOR_CREATE",
        label: "Add New Doctor",
        desc: "Allows the user to add new doctor",
      },
      {
        id: "DOCTOR_EDIT",
        label: "Edit Doctor",
        desc: "Allows the user to edit doctor details",
      },
      {
        id: "DOCTOR_DELETE",
        label: "Delete Doctor",
        desc: "Allows the user to delete doctor",
      },
      {
        id: "DOCTOR_VIEW",
        label: "View Doctor Master",
        desc: "Allows the user to view and export doctor master",
      },
      {
        id: "DISTRIBUTOR_CREATE",
        label: "Add New Distributor",
        desc: "Allows the user to add new distributor",
      },
      {
        id: "DISTRIBUTOR_EDIT",
        label: "Edit Distributor",
        desc: "Allows the user to edit distributor details",
      },
      {
        id: "DISTRIBUTOR_DELETE",
        label: "Delete Distributor",
        desc: "Allows the user to distributor doctor ",
      },
      {
        id: "DISTRIBUTOR_VIEW",
        label: "View Distributor",
        desc: "Allows the user to view and export distributor master",
      },
      {
        id: "DISTRIBUTOR_REMAP",
        label: "Merge Distributor",
        desc: "Allows the user to merge two distributors",
      },
      {
        id: "MEDICINE_CREATE",
        label: "Add New Product",
        desc: "Allows the user to add new product",
      },
      {
        id: "MEDICINE_EDIT",
        label: "Edit Product",
        desc: "Allows the user to edit product details",
      },
      {
        id: "MEDICINE_VIEW",
        label: "View Product",
        desc: "Allows the user to view and export product master",
      },
      {
        id: "MEDICINE_REMAP",
        label: "Merge Product",
        desc: "Allows the user to merge two products",
      },
      {
        id: "REPORT_ITEM_GROUP",
        label: "View Item Group Master",
        desc: "Allows the user to view and export item group report",
      },
      {
        id: "ITEM_GROUP_EDIT",
        label: "Edit Item Group",
        desc: "Allow users to edit item group",
      },
      {
        id: "ITEM_GROUP_DELETE",
        label: "Delete Item Group",
        desc: "Allow users to delete item group",
      },
      {
        id: "REPORT_SERVICE_ITEM_MASTER",
        label: "View Service Item Master",
        desc: "View and export service item master report",
      },
      {
        id: "SERVICE_ITEM_DELETE",
        label: "Delete Service Item",
        desc: "Allow users to delete service item",
      },
      {
        id: "SERVICE_ITEM_EDIT",
        label: "Edit Service Item",
        desc: "Allow users to edit service item",
      },
      {
        id: "REPORT_BANK_MASTER",
        label: "View Bank Master",
        desc: "Allow users to view and export bank master",
      },
      {
        id: "REPORT_TRANSPORT_MASTER",
        label: "View Transport Master",
        desc: "Allow users to view and export transport master",
      },
      {
        id: "REPORT_HSN_MASTER",
        label: "View HSN Master",
        desc: "Allow users to view and export HSN master",
      },
      {
        id: "REPORT_MANUFACTURER_MASTER",
        label: "View Manufacturer Master",
        desc: "Allow users to view and export manufacturer master",
      },
      {
        id: "REPORT_MANUFACTURER_GROUP_MASTER",
        label: "View Manufacturer Group Master",
        desc: "Allow users to view and export manufacturer group master",
      },
    ],
  },
  {
    groupId: "STOCK",
    groupLabel: "Stock",
    privileges: [
      {
        id: "BATCH_ADJUST_STOCK",
        label: "Stock Adjustment",
        desc: "Allows the user to adjust the stock in batch stock report",
      },
      {
        id: "AUDITING_CREATE",
        label: "Stock Audit",
        desc: "Allows the user to create new stock audit",
      },
      {
        id: "AUDITING_VIEW",
        label: "Stock Audit Report",
        desc: "Allows the user to view stock audit entries",
      },
      {
        id: "REPORT_STOCK_AUDIT_DETAILS",
        label: "Stock Audit Details Report",
        desc: "View and export product wise stock audit report",
      },
      {
        id: "REPORT_CONSOLIDATED_STOCK_AUDIT_DETAILS",
        label: " Consolidated Stock Audit Report",
        desc: "View and Export the consolidated stock audit report",
      },
      {
        id: "REPORT_DATE_WISE_STOCK_AUDIT",
        label: "Date Wise Stock Audit Report",
        desc: "View and Export the date wise stock audit report",
      },
    ],
  },
  {
    groupId: "DASHBOARD",
    groupLabel: "Dashboard",
    privileges: [
      {
        id: "DASHBOARD_VIEW_SALES",
        label: "Dashboard-Sales",
        desc: "Allows the user to view sales dashboard",
      },
      {
        id: "DASHBOARD_VIEW_PURCHASE",
        label: "Dashboard-Purchase",
        desc: "Allows the user to view purchase dashboard",
      },
      {
        id: "DASHBOARD_VIEW_STOCK",
        label: "Dashboard-Stock",
        desc: "Allows the user to view dashboard",
      },
      {
        id: "DASHBOARD_VIEW_PAYMENTS",
        label: "Dashboard-Payments",
        desc: "Allows the user to view dashboard",
      },
    ],
  },
  {
    groupId: "SHIFT_MANAGEMENT",
    groupLabel: "Shift Management",
    privileges: [
      {
        id: "SHIFT_MANAGEMENT_CREATE",
        label: "Allow Shift",
        desc: "Allows the user to create and close shifts",
      },
      {
        id: "SHIFT_MANAGEMENT_SUMMARY",
        label: "Shift Summary Report",
        desc: "Allows the user to view user wise shift summary report",
      },
      {
        id: "SHIFT_MANAGEMENT_SHOWALL",
        label: "Show All Shifts",
        desc: "Allows the user to view all users shift summary report",
      },
      {
        id: "SHIFT_MANAGEMENT_REVIEW",
        label: "Approve Shift Denominations",
        desc: "Allows the user to approve shift cash denominations",
      },
      {
        id: "SHIFT_MANAGEMENT_EDIT",
        label: "Edit Shift Denominations",
        desc: "Allows the user to edit shift cash denominations",
      },
      {
        id: "SHIFT_MANAGEMENT_DAY_END",
        label: "Perform Day End",
        desc: "Allows the user to day end shifts",
      },
      {
        id: "REPORT_DAY_END",
        label: "Edit Day End Activity",
        desc: "Allows the user to undo day end activity",
      },
    ],
  },
  {
    groupId: "REPORTS",
    groupLabel: "Reports",
    privileges: [
      {
        id: "REPORT_BATCH_STOCK",
        label: "Batch Stock",
        desc: "Allows the user to view and export batch stock report",
      },
      {
        id: "REPORT_MEDICINE_STOCK",
        label: "Product Stock",
        desc: "Allows the user to view and export product stock report",
      },
      {
        id: "REPORT_TRANSACTION",
        label: "Transaction Report",
        desc: "Allows the user to view and export trasnaction stock report",
      },
      {
        id: "REPORT_STOCK_ADJUSTMENT",
        label: "Stock Adjustment Report",
        desc: "Allows the user to view and export stock adjustment report",
      },
      {
        id: "REPORT_CREDIT_NOTE_TRACKING",
        label: "Credit Note Tracking",
        desc: "Allows the user to view and export credit note report",
      },
      {
        id: "REPORT_EXPIRY_ALERT",
        label: "Expiry Alert Report",
        desc: "Allows the user to view and export near expiry and expired stock report",
      },
      {
        id: "REPORT_MEDICINE_WISE_SALES",
        label: "Sales By Product",
        desc: "Allows the user to view and export product wise sales report",
      },
      {
        id: "REPORT_MEDICINE_WISE_SALES_RETURN",
        label: "Sales Return By Product",
        desc: "Allows the user to view and export product wise sales return report",
      },
      {
        id: "REPORT_MEDICINE_WISE_PURCHASE",
        label: "Purchase By Product",
        desc: "Allows the user to view and export product wise purchase report",
      },
      {
        id: "REPORT_MEDICINE_WISE_PURCHASE_RETURN",
        label: "Purchase Return By Product",
        desc: "Allows the user to view and export product wise purchase return report",
      },
      {
        id: "REPORT_HSN_WISE_SALES",
        label: "HSN Wise Sales",
        desc: "Allows the user to view and export HSN wise product sales report",
      },
      {
        id: "REPORT_HSN_WISE_PURCHASE",
        label: "HSN Wise Purchase",
        desc: "Allows the user to view and export HSN wise product purchase report",
      },
      {
        id: "REPORT_GST_SALES",
        label: "GST Sales",
        desc: "View and export GST breakdowns for sales transactions",
      },
      {
        id: "REPORT_GST_PURCHASE",
        label: "GST Purchase",
        desc: "View and export GST breakdowns for purchase transactions",
      },
      {
        id: "REPORT_GST_SALES_RETURN",
        label: "GST Sales Return",
        desc: "View and export GST breakdowns for sales return transactions",
      },
      {
        id: "REPORT_GST_PURCHASE_RETURN",
        label: "GST Purchase Return",
        desc: "View and export GST breakdowns for purchase return transactions",
      },
      {
        id: "REPORT_INVOICE_WISE_TB",
        label: "TB Report Invoice Wise",
        desc: "View and export Invoice Wise TB report",
      },
      {
        id: "REPORT_MEDICINE_WISE_TB",
        label: "TB Report Product Wise",
        desc: "View and export Product Wise TB report",
      },
      {
        id: "REPORT_SCHEDULED_DRUG_SALES",
        label: "Scheduled Drug Sales Report",
        desc: "View and export schduled drug sales report",
      },
      {
        id: "REPORT_SCHEDULED_DRUG_STOCK",
        label: "Scheduled Drug Stock Report",
        desc: "View and export scheduled drug stock report",
      },
      {
        id: "PATIENT_PAYMENT_TXN_VIEW",
        label: "Customer Payment Txn",
        desc: "View and export cust. payment transaction. Provides cash,card,upi breakup of sales invoices",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_TXN_VIEW",
        label: "Distributor Payment Txn",
        desc: "View and export distributor payment transaction invoice wise.",
      },
      {
        id: "REPORT_DATE_WISE_SALES",
        label: "Date Wise Sales",
        desc: "View and export daily/date wise sales",
      },
      {
        id: "REPORT_CATEGORY_WISE_STOCK",
        label: "Category Wise Stock Report",
        desc: "View and export category wise stock report",
      },
      {
        id: "REPORT_SALES_STAGE_ORDER",
        label: "Stage Order Report",
        desc: "View and export stage order report",
      },
      {
        id: "SALES_SHOW_ALL_STAGE_BILL",
        label: "Show All Stage Orders",
        desc: "Allows the user to view stage orders from all users",
      },
      {
        id: "ACCOUNTING_GST_TALLY_EXPORT",
        label: "Tally Export Report",
        desc: "Export accounting data for Tally",
      },
      {
        id: "REPORT_VIEW_SUMMARY",
        label: "View Summary and Export",
        desc: "Allows the user to view summary and export the reports",
      },
      {
        id: "REPORT_PRODUCT_LEDGER",
        label: "Date Wise Product Ledger Report",
        desc: "View and export date wise product ledger report",
      },
      {
        id: "REPORT_SALES_VS_STOCK",
        label: "Product Sales vs Stock in Hand Report",
        desc: "View and export product wise sales vs stock in hand report",
      },
      {
        id: "REPORT_TOP_SELLING_PRODUCT",
        label: "Top Selling Product Report",
        desc: "View and export top selling product report",
      },
      {
        id: "REPORT_LOW_SELLING_PRODUCT",
        label: "Low Selling Product Report",
        desc: "View and export low selling product report",
      },
      {
        id: "REPORT_MONTH_WISE_SALES_SUMMARY",
        label: "Month Wise Sales Report",
        desc: "View and export month wise sales report",
      },
      {
        id: "REPORT_SHIFT_HOUR_WISE_SALES",
        label: "Hourly Sales Report",
        desc: "View and export hourly sales report",
      },
      {
        id: "REPORTS_MEDICINE_WISE_STOCK_REQUEST",
        label: "Medicine Wise Stock Request Report",
        desc: "View and export medicine wise stock request report",
      },
      {
        id: "REPORTS_MEDICINE_WISE_STOCK_TRANSFER",
        label: "Medicine Wise Stock Transfer Report",
        desc: "View and export medicine wise stock transfer report",
      },
      {
        id: "REPORT_REFILL_ORDER",
        label: "Refiil Order Report",
        desc: "View and export refill order report",
      },
      {
        id: "REPORT_SUPPLIER_OUTSTANDING",
        label: "Distributor Outstanding Report",
        desc: "View and export distributor outstanding report",
      },
      {
        id: "REPORT_HSN_SUMMARY",
        label: "Hsn Summary Report",
        desc: "View and export hsn summary report",
      },
      {
        id: "DISCOUNT_PROGRAM_VIEW",
        label: "Discount Program Report",
        desc: "View and export discount program report",
      },
      {
        id: "REPORT_DOCTOR_COMMISSION",
        label: "Doctor Commission Report",
        desc: "View and export doctor commission report",
      },
      {
        id: "REPORT_DOCTOR_COMMISSION",
        label: "Doctor Commission Details Report",
        desc: "View and export doctor commission details report",
      },
      {
          id: "REPORT_HSN_PURCHASE_SUMMARY",
          label: "HSN Purchase Summary Report",
          desc: "View and export HSN purchase summary report",
      },
      {
        id: "REPORT_HSN_SALES_SUMMARY",
        label: "HSN Sales Summary Report",
        desc: "View and export HSN sales summary report",
      },
      {
        id: "REPORT_EDITED_SALES",
        label: "Edited Sales Report",
        desc: "View and export edited sales report",
      },
    ],
  },
];
export const initial_state_roles = {
  type: ROLES_TAB,
  label: "Roles",
  allowMultipleTabs: false,
};
export const roleLogsColDefs = [
  {
    headerName: "Role Id",
    field: "roleId",
    maxWidth: 200,
  },
  {
    headerName: "Updated Time",
    field: "created_at",
    maxWidth: 200,
    valueGetter: (params) => {
      return moment(`${params.data.created_at}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  {
    headerName: "Log Details",
    field: "message",
  },
];
export const roleColDefsForExport = [
  {
    headerName: "Role",
    field: "role",
    maxWidth: 200,
  },
  {
    headerName: "Updated Time",
    field: "updatedTime",
    maxWidth: 200,
    valueGetter: (params) => {
      return moment(`${params.data.updatedTime}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  {
    headerName: "Privileges",
    field: "privileges",
  },
];
